import { isMobile } from 'react-device-detect'

export const openWindow = (phone) => {
  phone = phone.replace(/\D/g, '')

  const url = isMobile
    ? `https://wa.me/55${phone}`
    : `https://web.whatsapp.com/send?phone=55${phone}`

  if (isMobile) {
    window.open(url, '_blank').focus()
  } else {
    // open popup
    const newWindow = window.open(url, 'wpp-window', 'resizable=1,height=750,width=750')
    if (window.focus) {
      newWindow.focus()
    }
  }
}
